import { render, staticRenderFns } from "./ThuxTableChecksColumn.vue?vue&type=template&id=217a9db3&"
import script from "./ThuxTableChecksColumn.vue?vue&type=script&lang=js&"
export * from "./ThuxTableChecksColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports